// extracted by mini-css-extract-plugin
export default {"container":"MobileMenu_container__EJf3U","backdrop":"MobileMenu_backdrop__hT-Nx","mobileMenu":"MobileMenu_mobileMenu__w5thM"};